export const isMinted = (nft) => {
    if (nft.transaction)
        return (nft.transaction.toUpperCase() != "PRE_MINT")
    return false
}